/**
 * Permission Lock Slice
 * Drives the global permission-restriction lock dialog (see
 * PermissionLockDialog.tsx). Sibling to planLockSlice.ts — same
 * open/payload/show/hide shape — but for RBAC denials (the user's role
 * doesn't grant an action) rather than plan-tier denials (the tenant's plan
 * doesn't include a feature). Kept as a separate slice/dialog rather than
 * reusing planLockSlice because PlanLockDialog's CTA is "Upgrade Plan," which
 * makes no sense for a permission denial — upgrading a plan doesn't grant a
 * role more access.
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PermissionLockPayload {
  title: string;
  message: string;
}

export interface PermissionLockState {
  open: boolean;
  payload: PermissionLockPayload | null;
}

const initialState: PermissionLockState = {
  open: false,
  payload: null,
};

const permissionLockSlice = createSlice({
  name: 'permissionLock',
  initialState,
  reducers: {
    showPermissionLock: (state, action: PayloadAction<PermissionLockPayload>) => {
      state.open = true;
      state.payload = action.payload;
    },
    hidePermissionLock: (state) => {
      state.open = false;
    },
  },
});

export const { showPermissionLock, hidePermissionLock } = permissionLockSlice.actions;
export default permissionLockSlice.reducer;
